import React, { useState } from 'react'
import * as classes from './footer.module.scss'
import { SiInstagram, SiYoutube } from 'react-icons/si'
import { MdCheckCircle, MdArrowForward } from 'react-icons/md'
import { Link } from 'gatsby';
import { joinWaitlist } from '../../services/waitlistService'

function FooterEmailForm() {
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [done, setDone] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return

        setLoading(true)
        try {
            await joinWaitlist({ email, source: 'footer-form' })
        } catch (_) {
            // Treat duplicate (200) and network errors the same — show success
        } finally {
            setLoading(false)
            setDone(true)
        }
    }

    if (done) {
        return <p className={classes.footerFormDone}><MdCheckCircle size={18} style={{ color: '#22c55e', verticalAlign: 'middle', marginRight: '6px' }} />You're on the list!</p>
    }

    return (
        <form className={classes.footerEmailForm} onSubmit={handleSubmit} noValidate>
            <input
                className={classes.footerEmailInput}
                type="email"
                placeholder="Your email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
            />
            <button type="submit" className={classes.footerEmailBtn} disabled={loading}>
                {loading ? '...' : <>Join <MdArrowForward size={14} style={{ verticalAlign: '-2px', marginLeft: '2px' }} aria-hidden="true" /></>}
            </button>
        </form>
    )
}

function Footer() {
    return (
        <>
            <div className={classes.footer}>
                <div className={classes.dfooter}>

                    <div className={classes.brandCol}>
                        <p className={classes.brandName}>Crickonnect</p>
                        <p className={classes.brandDesc}>
                            The grassroots cricket platform built for captains who want real control — match booking, team management, and tournament organisation in one place.
                        </p>
                        <FooterEmailForm />
                        <div className={classes.socialIcons}>
                            <a href="https://www.instagram.com/cric_konnect_?igsh=MWhrZHZnMDRkaWE4OA==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram">
                                <SiInstagram size={22} />
                            </a>
                            <a href="https://www.youtube.com/@Crick_connect10" target="_blank" rel="noopener noreferrer" aria-label="Subscribe to our YouTube channel">
                                <SiYoutube size={22} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <Link to="/matches"><p>Matches</p></Link>
                        <Link to="/tournaments"><p>Tournaments</p></Link>
                    </div>
                    <div>
                        <Link to="/field-marshal"><p>Field Marshal</p></Link>
                        <Link to="/field-positions"><p>Field Positions</p></Link>
                        <Link to="/bowling-plans"><p>Bowling Plans</p></Link>
                        <Link to="/dls-calculator"><p>DLS Calculator</p></Link>
                        <Link to="/guess-the-legend"><p>Guess the Legend</p></Link>
                        <Link to="/cricket-codex"><p>Cricket Codex</p></Link>
                        <Link to="/cricket-laws"><p>The Rulebook</p></Link>
                    </div>
                    <div>
                        <a href="mailto:contact@crickonnect.com"><p>Contact us</p></a>
                        <Link to="/blog"><p>The Nightwatchman Notes</p></Link>
                    </div>
                    <div>
                        <Link to="/privacy-policy"><p>Privacy policy</p></Link>
                        <Link to="/terms-of-service"><p>Terms of service</p></Link>
                    </div>

                </div>

                <div>
                    <div className={classes.bbottom}></div>
                    <div className={classes.footerBottom}>
                        <p className={classes.copyright}>
                            © Crickonnect {new Date().getFullYear()}. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
